/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { notificationHoldersConfig } from '../../config/notifications.config';

export interface IStaticHoldersPagePluginMethods extends IPluginMethodMap {
  getStaticHoldersPageSync(): any;
}

export class StaticHoldersPagePlugin implements IAgentPlugin {
  readonly methods: IStaticHoldersPagePluginMethods;

  constructor() {
    this.methods = {
      getStaticHoldersPageSync: this.getStaticHoldersPageSync.bind(this),
    };
  }

  getStaticHoldersPageSync() {
    return {
      notifications: notificationHoldersConfig,
    };
  }
}
